import React from 'react';
import { Form, Row, Col, Container } from 'react-bootstrap'
import { SelectBox } from './SelectBox';

// General Bootstrap component that presents a labeled selection list like this:
// Label: [ListBox (stretches 100% ==>)    ]
// and fires onSelectionChanged when the selected value changes.
export const LabeledSelectBox = ({
    label, // Text for listbox label. If not set, listbox is unlabeled.
    items, // ...see SelectBox for other props
    itemValueSelector,
    itemTextSelector,
    selectedValue,
    onSelectionChanged
}) => {
    const labelElement = label
        ? <Form.Label column sm="2" md="50">
            {`${label}: `}
        </Form.Label>
        : null;
    return (
        <Container>
            <Form onSubmit={(event) => event.preventDefault()}>
                <Form.Group as={Row}>
                    {labelElement}
                    <Col sm="10" md="100%">
                        <SelectBox
                            items={items}
                            itemValueSelector={itemValueSelector}
                            itemTextSelector={itemTextSelector}
                            selectedValue={selectedValue}
                            onSelectionChanged={(value) => onSelectionChanged && onSelectionChanged(value)}
                        />
                    </Col>
                </Form.Group>
            </Form >
        </Container>
    )
}
